<nav class="mainNav">
  <div class="mainNav-item" *ngFor="let item of menu; let i = index;"
    [ngClass]="{'isHover': currentSubmenu === i}"
    (mouseenter)="toggleSubMenu(i)"
    (mouseleave)="toggleSubMenu(null)"
  >
    <a class="mainNav-link" [routerLink]="item.route" routerLinkActive="mainNav-link_active">
      {{ item.title | translate }}
    </a>
    <div class="mainNav-submenuWrapper">
      <div class="mainNav-submenu">
        <ng-container *ngIf="item.title === 'NAV.OFFERS' && !lastVisitedOffer.hideNavItem">
          <a class="mainNav-submenuLink" (click)="goToCurrentOffer()">
            <span class="copy_normal copy_tiny">
              {{ "NAV.CURRENT_OFFER_NR" | translate }}
              {{lastVisitedOffer.data.title}}
            </span>
            <br>
            {{ "NAV.CURRENT_OFFER" | translate }}
          </a>
        </ng-container>

        <ng-container *ngFor="let subItem of item.subItems">
          <a class="mainNav-submenuLink" [ngClass]="{'mainNav-submenuLink_cta': !subItem.route}"
            [routerLink]="subItem.route" (click)="!subItem.route ? onNavItemClick(subItem.title) : null; toggleSubMenu(null)">
            <i *ngIf="!subItem.route && subItem.img" svgIcon [icon]="subItem.img"></i>
            {{ subItem.title | translate }}
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</nav>
